import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './auth-context';
import './../globals/vars.css'; // Importa o CSS para o tema
import { isMyLove } from '../utils/auth';
import "../components/screen/style.css";

interface ThemeContextType {
  isDarkMode: boolean;
  isNewUI: boolean;
  isNewPacoca: boolean;
  isPacocagram: boolean;
  hideCensorship: boolean;
  hideMenuMobile: boolean;
  isLiquidGlass: boolean;
  isBlueTheme: boolean;
  hideBranToken: boolean;
  hideChatGlobal: boolean;
  toggleDarkMode: () => void;
  toggleNewUi: () => void;
  toggleNewPacoca: () => void;
  togglePacocagram: () => void;
  toggleHideCensorship: () => void;
  toggleHideMenuMobile: () => void;
  toggleIsLiquidGlass: () => void;
  toggleBlueTheme: () => void;
  toggleHideBranToken: () => void;
  toggleHideChatGlobal: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('dark-mode');
    return savedMode === 'true';
  });

  const [isNewUI, setIsNewUI] = useState(() => {
    const savedMode = localStorage.getItem('new-ui');
    return savedMode === 'true';
  });
 
  const [isBlueTheme, setIsBlueTheme] = useState(() => {
    const savedMode = localStorage.getItem('blue-theme');
    return savedMode === 'true';
  });

  const [isNewPacoca, setIsNewPacoca] = useState(() => {
    const savedMode = localStorage.getItem('new-pacoca');
    return savedMode === 'true' || !savedMode;
  });

  const [isPacocagram, setIsPacocagram] =useState(() => {
    const savedMode = localStorage.getItem('pacocagram');
    return savedMode === 'true';
  });

  const [hideCensorship, setIsHideCensorship] =useState(() => {
    const savedMode = localStorage.getItem('hide-censorship');
    return savedMode === 'true' || !savedMode;
  });

  const [hideBranToken, setHideBranToken] =useState(() => {
    const savedMode = localStorage.getItem('hide-brantoken');
    return savedMode === 'true';
  });

  const [hideMenuMobile, setHideMenuMobile] =useState(() => {
    const savedMode = localStorage.getItem('hide-menu-mobile');
    return savedMode === 'true';
  });

  const [isLiquidGlass, setIsLiquidGlass] =useState(() => {
    const savedMode = localStorage.getItem('liquid-glass');
    return savedMode === 'true';
  });
  
  const [hideChatGlobal, setHideChatGlobal] =useState(() => {
    const savedMode = localStorage.getItem('hide-chat-global');
    return savedMode === 'true';
  });

  const toggleDarkMode = () => {
    setIsDarkMode(prevMode => !prevMode);
  };

  const toggleBlueTheme = () => {
    setIsBlueTheme(prevMode => !prevMode);
  };

  const toggleHideBranToken = () => {
    setHideBranToken(prevMode => !prevMode);
  };

  const toggleIsLiquidGlass = () => {
    setIsLiquidGlass(prevMode => {
      if(!prevMode) setIsNewUI(false);
      return !prevMode;
    });
  };

  const toggleHideMenuMobile = () => {
    setHideMenuMobile(prevMode => !prevMode);
  };

  const toggleNewUi = () => {
    setIsNewUI(prevMode => {
      if(!prevMode) setIsLiquidGlass(false);
      return !prevMode;
    });
  };

  const toggleNewPacoca = () => {
    setIsNewPacoca(prevMode => !prevMode);
  };

  const togglePacocagram = () => {
    setIsPacocagram(prevMode => !prevMode);
  };

  const toggleHideCensorship = () => {
    setIsHideCensorship(prevMode => !prevMode);
  };

  const toggleHideChatGlobal = () => {
    setHideChatGlobal(prevMode => !prevMode);
  };

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', isDarkMode);
    localStorage.setItem('dark-mode', String(isDarkMode));
    // if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function') {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({ statusBarStyle: isDarkMode ? "#000" : "#fff" }));
    // }
  }, [isDarkMode]);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('blue-theme', isBlueTheme);
    localStorage.setItem('blue-theme', String(isBlueTheme));
  }, [isBlueTheme]);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('new-ui', isNewUI);
    localStorage.setItem('new-ui', String(isNewUI));
  }, [isNewUI]);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('new-pacoca', isNewPacoca);
    localStorage.setItem('new-pacoca', String(isNewPacoca));
  }, [isNewPacoca]);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('pacocagram', isPacocagram);
    localStorage.setItem('pacocagram', String(isPacocagram));
  }, [isPacocagram]);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('hide-censorship', hideCensorship);
    localStorage.setItem('hide-censorship', String(hideCensorship));
  }, [hideCensorship]);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('hide-menu-mobile', hideMenuMobile);
    localStorage.setItem('hide-menu-mobile', String(hideMenuMobile));
  }, [hideMenuMobile]);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('liquid-glass', isLiquidGlass);
    localStorage.setItem('liquid-glass', String(isLiquidGlass));
  }, [isLiquidGlass]);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('hide-brantoken', hideBranToken);
    localStorage.setItem('hide-brantoken', String(hideBranToken));
  }, [hideBranToken]);

  useEffect(() => {
    const root = document.documentElement;
    const localIsMyLove = localStorage.getItem('is-my-love') === 'true';
    const isUserMyLove = isMyLove(user);

    if (localIsMyLove || isUserMyLove) {
      root.classList.add('my-love');
    } else {
      root.classList.remove('my-love');
    }

    if (isUserMyLove) {
      localStorage.setItem('is-my-love', 'true');
    } else {
      localStorage.removeItem('is-my-love');
    }
  }, [user]);

  return (
    <ThemeContext.Provider 
      value={{ 
        isDarkMode, toggleDarkMode, 
        isNewUI, toggleNewUi, 
        isNewPacoca, toggleNewPacoca, 
        isBlueTheme, toggleBlueTheme, 
        hideBranToken, toggleHideBranToken, 
        isLiquidGlass, toggleIsLiquidGlass,
        togglePacocagram, isPacocagram, 
        toggleHideCensorship, hideCensorship, 
        toggleHideMenuMobile, hideMenuMobile,
        toggleHideChatGlobal, hideChatGlobal,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
